module.exports = __webpack_public_path__ + "static/media/5B.bd332656.jpg";